import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { CreateCardAccountStackRoutes, CreateCardAccountStackScreenProps } from './type';
import { CreateCardAccountWebDocumentScreen } from './CreateCardAccountWebDocument.screen';
import { CreateCardAccountNativeDocumentScreen } from './CreateCardAccountNativeDocument.screen';

export const CreateCardAccountDocument: React.FC<CreateCardAccountStackScreenProps<CreateCardAccountStackRoutes.Document>> = ({
  navigation,
  route
}) => {
  const { onLayout, data, onData, func, onReturnData, refresh, onChangeView } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <CreateCardAccountNativeDocumentScreen
        onClose={onGoBack}
        onLayout={onLayout}
        data={data}
        onData={onData}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
      />
    );
  }

  return (
    <CreateCardAccountWebDocumentScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      onData={onData}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
      onChangeView={onChangeView}
    />
  );
};
